





















































































































































import { Component, Vue, Prop } from 'vue-property-decorator'

@Component
export default class HomePage extends Vue {
  samples = ['sample1', 'sample2', 'sample3', 'sample4']
  infos = [
    {
      number: 4453,
      unit: 'Videos',
    },
    {number: 7822, unit: 'Unique Objects'},
    {number: 191378, unit: 'Human Annotations'},
    {number: 345, unit: 'Minutes'},
  ]
  expandinfo(info: any) {
    return `The data set consists of ${info['number']} ${info['unit']}`
  }

  organizers = [
    {
      name:'Ning Xu',
      affiliation:'Adobe Research',
      im_name:'NingXu',
      link: 'https://sites.google.com/view/ningxu/homepage'
    }, {
      name:'Linjie Yang',
      affiliation: 'ByteDance AI Lab',
      im_name: 'LinjieYang'
    }, {
      name: 'Jianchao Yang',
      affiliation: 'ByteDance AI Lab',
      im_name: 'JianchaoYang'
    }, {
      name: 'Dingcheng Yue',
      affiliation: 'UIUC',
      im_name: 'DingchengYue'
    }, {
      name: 'Yuchen Fan',
      affiliation: 'UIUC',
      im_name: 'YuchenFan'
    }, {
      name: 'Yuchen Liang',
      affiliation: 'UIUC',
      im_name: 'YuchenLiang'
    }, {
      name: 'Thomas Huang',
      affiliation: 'UIUC',
      im_name: 'Tom'
    },
  ]

  sponsors = [
    {name:'Snapchat', im_name:'snapchat.jpg'},
    {name:'Adobe',  im_name:'adobe.png'},
    {name:'UIUC', im_name:'uiuc-alt.jpg'},
    {name:'CAS', im_name:'cas.jpg'},
  ]

}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/home.vue